import { internalFetch } from '../utils/fetchHelper';
import { IIsueType } from './issueService';

export interface IAssetCategory {
  id?: number;
  code: string;
  name: string;
  subCategories?: IAssetCategory[];
  parentId?: number;
  issueTypes?: IIsueType[];
}

export interface ICreateCategoryRequest {
  code: string;
  name: string;
  parentId?: number;
  issueTypes?: IIsueType[];
}

export interface IUpdateCategoryRequest {
  code: string | undefined;
  name: string | undefined;
  parentId: number | undefined;
  issueTypes?: IIsueType[];
}

export interface ICreateCategoryResponse {
  assetCategoryId: number;
}

export const getAssetCategories = async (
  abortController: AbortController
): Promise<IAssetCategory[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/assetCategories`,
    'GET',
    abortController
  );
};

export const editCategory = async (
  abortController: AbortController,
  categoryId: string,
  category: IUpdateCategoryRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetCategory?assetCategoryId=${categoryId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(category)
  );
};

export const createCategory = async (
  abortController: AbortController,
  category: ICreateCategoryRequest
): Promise<ICreateCategoryResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/assetCategory`,
    'POST',
    abortController,
    JSON.stringify(category)
  );
};

export const deleteCategory = async (
  abortController: AbortController,
  categoryId: number
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetCategory?assetCategoryId=${categoryId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'DELETE',
    abortController
  );
};

export const getAssetCategoryIssueTypes = async (
  abortController: AbortController,
  assetCategoryId: string
): Promise<IIsueType[]> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetCategoryIssueTypes?assetCategoryId=${assetCategoryId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};
